// frontend/src/contexts/SubscriptionNotificationContext.js
import React, { createContext, useContext } from 'react';
import useAuthToken from '../hooks/useAuthToken';
import useSubscriptionNotifications from '../hooks/useSubscriptionNotifications';

/**
 * Subscription Notification Context
 * 
 * Provides global subscription change notification management throughout the app.
 * Automatically detects JWT token invalidation and prompts users to refresh.
 */
const SubscriptionNotificationContext = createContext();

export const SubscriptionNotificationProvider = ({ children }) => {
  const token = useAuthToken();
  const notifications = useSubscriptionNotifications(token);

  const contextValue = {
    ...notifications,
    token
  };

  return (
    <SubscriptionNotificationContext.Provider value={contextValue}>
      {children}
    </SubscriptionNotificationContext.Provider>
  );
};

export const useSubscriptionNotificationContext = () => {
  const context = useContext(SubscriptionNotificationContext);
  if (!context) {
    throw new Error(
      'useSubscriptionNotificationContext must be used within a SubscriptionNotificationProvider'
    );
  }
  return context;
};

export default SubscriptionNotificationContext;